import React from "react";
import * as Icons from "lucide-react";
import { APPLICATIONS, IMG } from "@/lib/content";

const imgMap = {
  industry: IMG.industry,
  traffic: IMG.traffic,
  logistics: IMG.logistics,
  kritis: "/images/apps/kritis.jpg",
  energy: "/images/apps/energy.jpg",
  cities: "/images/apps/cities.jpg",
  perimeter: "/images/apps/perimeter.jpg",
  security: "/images/apps/security.jpg",
};

export default function Applications() {
  return (
    <section
      id="anwendungen"
      data-testid="applications-section"
      className="relative bg-[#0B1220] text-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="tag-line text-xs font-mono-tech uppercase tracking-[0.25em] text-white/60 mb-6">
            Anwendungsbereiche
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white tracking-tight">
            Wo Xortec im Einsatz ist.
          </h2>
          <p className="mt-6 text-white/70 text-base sm:text-lg leading-relaxed max-w-2xl">
            Vom Industriegelände bis zur kritischen Infrastruktur: Unsere
            Lösungen bilden die Grundlage für moderne Sicherheitssysteme in
            Unternehmen, Kommunen und kritischen Einrichtungen.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {APPLICATIONS.map((a, i) => {
            const Icon = Icons[a.icon] || Icons.Building;
            const bg = a.image ? imgMap[a.image] : null;
            return (
              <div
                key={a.title}
                data-testid={`application-${i}`}
                className="group relative aspect-[4/5] rounded-xl overflow-hidden border border-white/10 hover:border-[#5BA8FF]/50 transition-all"
              >
                {bg ? (
                  <img
                    src={bg}
                    alt={a.title}
                    className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                ) : (
                  <div className="absolute inset-0 bg-gradient-to-br from-[#0055A4]/40 via-[#0B1220] to-[#0B1220]" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1220] via-[#0B1220]/30 to-transparent" />

                <div className="absolute inset-0 p-5 flex flex-col justify-between">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 border border-white/20 backdrop-blur-md text-white">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <div className="font-mono-tech text-[10px] text-white/50 tracking-widest mb-1">
                      USE CASE · {String(i + 1).padStart(2, "0")}
                    </div>
                    <h3 className="font-display font-medium text-lg text-white">
                      {a.title}
                    </h3>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
